/**
 * Class Menu Primary.
 */
export default class MenuSticky {
  static lastScrollTop = 0;

  constructor() {
    const header: HTMLElement = document.querySelector('.l-header__container');
    const btnSticky: HTMLElement = document.querySelector('.c-menuSticky');

    if (header && btnSticky) {
      // CLick to btn sticky
      btnSticky.addEventListener(
        'click',
        () => {
          header.classList.toggle('is-opened');
        },
        { passive: true }
      );

      // Event scroll in page
      window.addEventListener('scroll', () => MenuSticky.scrollPage(header), {
        passive: true,
      });
    }
  }

  /*
   * Scroll in page
   * */
  private static scrollPage(header: HTMLElement): void {
    const positionPage: number =
      window.pageYOffset || document.documentElement.scrollTop;
    const pageContainer: HTMLElement = document.querySelector('.l-page, #body');

    if (positionPage < MenuSticky.lastScrollTop) {
      // Scroll top
      pageContainer.classList.add('js-sticky-top');
    } else {
      // Scroll down
      pageContainer.classList.remove('js-sticky-top');
    }

    // For Mobile or negative scrolling
    MenuSticky.lastScrollTop = positionPage <= 0 ? 0 : positionPage;

    MenuSticky.menuSticky(header, pageContainer);
  }

  /*
   * Add the sticky class to the header when you reach its scroll position.
   * Remove "sticky" when you leave the scroll position
   * */
  private static menuSticky(
    header: HTMLElement,
    pageContainer: HTMLElement
  ): void {
    const heightHeader: HTMLElement = document.querySelector('.l-header');

    if (window.pageYOffset >= heightHeader.offsetHeight) {
      pageContainer.classList.add('js-sticky');
    } else {
      pageContainer.classList.remove('js-sticky', 'js-sticky-top');
      header.classList.remove('is-opened');
    }
  }
}
